<script>
import { DataAdminAPI } from '@/dataAdmin/api';
import ImportSpecificData from '@/dataAdmin/components/ImportSpecificData.vue';

export default {
  components: {
    ImportSpecificData,
  },

  data: function () {
    return {
      dataGroups: [
        {
          name: 'Broiler Batches',
          saveFunc: rawData => DataAdminAPI.saveRawBroilerBatches(JSON.parse(rawData)),
          htmlWarningFromDataFunc: rawData => {
            let parsedNames = (JSON.parse(rawData || '[]') || []).map(x => `${x.number}`);
            return `Batches you import will <strong>overwrite</strong> existing batches ${parsedNames}.`;
          },
        },
        {
          name: 'Layer Batches',
          saveFunc: rawData => DataAdminAPI.saveRawLayerBatches(JSON.parse(rawData)),
          htmlWarningFromDataFunc: rawData => {
            let parsedNames = (JSON.parse(rawData || '[]') || []).map(x => `${x.name}`);
            return `Batches you import will <strong>overwrite</strong> existing batches ${parsedNames}.`;
          },
        },
      ],
    }
  },

  methods: {
    onGroupJsonDataInput(group, $event) {
      group.parsedUniqueNames = (JSON.parse($event.target.value || '[]') || []).map(x => `${x.number}`);
    },

    async saveGroup(group) {
      group.busySaving = true;
      try {
        let parsed = JSON.parse(group.jsonData);
        await group.saver(parsed);
      } finally {
        group.busySaving = false;
      }
    },
  },

}
</script>

<template>
  <b-card no-body>
    <b-tabs card>

      <b-tab v-for="group in dataGroups" :key="group.name" :title="group.name">

        <import-specific-data
          :name="group.name"
          :save-func="group.saveFunc"
          :html-warning-from-data-func="group.htmlWarningFromDataFunc" />

      </b-tab>

    </b-tabs>
  </b-card>
</template>



// WEBPACK FOOTER //
// src/dataAdmin/views/ImportDataView.vue